window.addEventListener('DOMContentLoaded', () => {
  const stickyATC = document.querySelector('#md-sticky-atc');
  if (!stickyATC) return;

  const mainAddBtn = document.querySelector('.product-form button[name="add"]');
  if (!mainAddBtn) return;

  const offset = Number(stickyATC.dataset.offset || 0);

  const updateStickyPosition = () => {
    const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    const scrollTop = window.visualViewport ? window.visualViewport.offsetTop : window.scrollY;

    const threshold = mainAddBtn.getBoundingClientRect().bottom + scrollTop + offset;

    if (scrollTop + viewportHeight < threshold + stickyATC.offsetHeight) {
      stickyATC.classList.add('show');

      // Correct padding for Chrome iOS gap
      const safeArea = parseInt(getComputedStyle(stickyATC).bottom) || 0;
      document.body.style.paddingBottom = `${stickyATC.offsetHeight + safeArea}px`;
    } else {
      stickyATC.classList.remove('show');
      document.body.style.paddingBottom = `${parseInt(getComputedStyle(stickyATC).bottom) || 0}px`;
    }
  };

  window.addEventListener('scroll', updateStickyPosition, { passive: true });
  window.visualViewport?.addEventListener('resize', updateStickyPosition);

  updateStickyPosition(); // initial check
});
